import { AnimatePresence, motion } from "framer-motion";
import type React from "react";

const Fade = (props: {
    show: boolean;
    children: React.ReactNode;
    duration?: number;
}) => {
    return (
        <AnimatePresence mode="wait">
            {props.show && (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: props.duration ?? 0.3 }}
                    style={{ overflow: "hidden" }}>
                    {props.children}
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export { Fade };
